export default __webpack_public_path__ + "static/media/lbh.4feaf708.jpeg";